import React, { useState } from 'react';
import {
    Table,
    Column,
    PrimaryButton,
    CommonModal
} from '../Common';
import Routes from '../../routes';
import { TextField } from '@mui/material';
// import { TextField } from '../Input';
import toast from 'react-hot-toast';

export const Alias = ({
    id,
}) => {
    const [showAddAlias, setShowAddAlias] = useState(false);
    const [showDeleteAlias, setShowDeleteAlias] = useState(false);
    const [clickedId, setClickedId] = useState(null);
    const [refreshgrid, setRefreshgrid] = useState(true);

    const closeAddAlias = () => setShowAddAlias(false);

    const closeDeleteAlias = () => setShowDeleteAlias(false);

    const saveAddAlias = () => {
        setShowAddAlias(false);
        setRefreshgrid(!refreshgrid);
    };

    const deleteClicked = (id) => {
        setClickedId(id);
        setShowDeleteAlias(true);
    };

    const saveDeleteAlias = () => {
        setShowDeleteAlias(false);
        setRefreshgrid(!refreshgrid);
    };

    return (
        <>
            <Table
                url={Routes.Location.LocationAliasTable(id)}
                refresh={refreshgrid}
                tableHeader="Aliases"
                noResultText="Oops...It is empty here..."
                noResultText2="Please add an Alias to get started."
            >
                <Column id='NameHeader' title="Name" property="name" />
                <Column title="" callbackLink={deleteClicked} linkId="id" icon="/images/ic_delete_location.svg" noSort="true" hover="Delete Alias" />
            </Table>

            <CommonModal open={showAddAlias} close={closeAddAlias}>
                <AddAlias id={id} saveCallback={saveAddAlias} />
            </CommonModal>

            <CommonModal open={showDeleteAlias} close={closeDeleteAlias}>
                <DeleteAlias id={clickedId} closeCallback={closeDeleteAlias} saveCallback={saveDeleteAlias} />
            </CommonModal>
        </>
    );
};

export function AddAlias(props) {
    const [newAlias, setNewAlias] = useState("");
    const [newAliasError, setnewAliasError] = useState(null);

    async function AddAlias(e) {

        if (newAlias == "") {
            setnewAliasError("This field is required");
            return;
        } else {
            setnewAliasError(null);
        }

        const response = await fetch(Routes.Location.AddAlias(props.id), {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ name: newAlias })
        })

        if (response.status === 200) {

            const newdata = await response.json();

            props.saveCallback();

        } else {
            toast.error('There was an error adding the new alias', { duration: 6000 });
        }

        setNewAlias("");
    }
    
    return (

        <div>
            <h1>Add Location Alias</h1>
            <div className="row mb-5">
                <div className="col-12">
                    <TextField
                        className=""
                        autoFocus
                        value={newAlias}
                        fullWidth
                        onChange={e => setNewAlias(e.target.value)}
                        label="Alias Name *"
                        error={newAliasError}
                        helperText={newAliasError}
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <PrimaryButton
                        buttonText='Save'
                        onClick={AddAlias}
                    />
                    {/* <Button size="lg" className="popup-button" type="submit" onClick={AddAlias}>
                        Save
                    </Button> */}
                </div>
            </div>

        </div>


    );
};

export function DeleteAlias(props) {
    
    async function DeleteAlias(e) {

        const response = await fetch(Routes.Location.DeleteAlias(props.id), {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
        })

        if (response.status === 200) {

            props.saveCallback();

        } else {
            toast.error('There was an error deleting the alias', { duration: 6000 });
        }

    }
    function CancelClick(e) {
        props.closeCallback();
    }

    return (

        <div>
            <h1>Delete Location Alias</h1>
            <h2>
                Are you sure you want to delete?
            </h2>

            <div className="row">
                <div className="col-12">
                    <PrimaryButton
                        buttonText='Cancel'
                        onClick={CancelClick}
                    />
                    <PrimaryButton
                        buttonText='Delete'
                        onClick={DeleteAlias}
                    />
                   {/*  <Button size="lg" className="popup-button mr-2" type="submit" onClick={CancelClick}>
                        Cancel
                    </Button >
                    <Button size="lg" className="popup-button" type="submit" onClick={DeleteAlias}>
                        Delete
                    </Button> */}
                </div>
            </div>

        </div>


    );
};
